export default {"src":"https://fishbrain.com/_next/static/media/fib-fish.bbe8e4ab.svg","height":18,"width":21,"blurWidth":0,"blurHeight":0};